import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useUnpublishRoom() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ roomId }: { roomId: string; hotelId: number }) => {
      return apiMutation('POST', {
        path: ENDPOINTS.unpublishRoom,
        params: { roomId: roomId.toString() },
      }) as Promise<void>;
    },
    onSuccess: (_, { hotelId }) => {
      message.success('Room status updated');
      queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.rooms, { hotelId }],
        exact: false,
      });
    },
    onError: () => {
      message.error('Error while modifying room status');
    },
  });
}
